import { normalizeDrippingDataFromMask } from 'helpers/Dripping';
import { htmlStringIsEmpty } from 'helpers/String';
import cloneDeep from 'lodash/cloneDeep';
import isEmpty from 'lodash/isEmpty';
import { toJS } from 'mobx';

import Store from './ContentPageStore';

class ContentPagePreventLeaveService {
  initSnapshot(snapshot) {
    const customSnapshot = this.customizeProps(snapshot);

    Store.snapshot = customSnapshot;
  }

  updateSnapshot() {
    const currentSnapshot = this.getCurrentSnapshot();

    this.initSnapshot(currentSnapshot);
  }

  getCurrentSnapshot() {
    const {
      academyBadgeType,
      attachments,
      backgroundImage,
      complementaryReadings,
      hotPassValue,
      mediaVideoUrl,
      tags
    } = Store;

    const current = cloneDeep({
      academyBadgeType,
      attachments: toJS(this.getAttachments(attachments)),
      backgroundImage: !isEmpty(backgroundImage) ? toJS(backgroundImage) : null,
      complementaryReadings: toJS(complementaryReadings),
      hotPassValue: this.getHotPassValue(hotPassValue),
      medias: toJS(this.getMedias()),
      page: toJS(this.getPage()),
      tags: toJS(tags)
    });

    // These attributes must be set separately as they don't come together in get endpoint.
    !isEmpty(mediaVideoUrl) && Object.assign(current, { mediaVideoUrl });

    return current;
  }

  getHotPassValue(value) {
    if (!value || (value && parseInt(value) === 0)) {
      return null;
    }

    return parseInt(value);
  }

  getAttachments(attachments) {
    if (attachments) {
      return attachments.map((attachment) => {
        return {
          id: attachment.id,
          name: attachment.name,
          size: attachment.size,
          contentType: attachment.contentType,
          fileOrder: attachment.fileOrder,
          thumborSignedUrl: attachment.thumborSignedUrl,
          creationDate: attachment.creationDate
        };
      });
    }

    return [];
  }

  getMedias() {
    const { medias } = Store;

    return medias.map((media) => {
      return {
        contentType: media.contentType,
        countAssociation: media.countAssociation,
        creationDate: media.creationDate,
        entityId: media.entityId,
        expirationDate: media.expirationDate,
        fileOrder: media.fileOrder,
        fileSignedUrl: media.fileSignedUrl,
        id: media.id,
        name: media.name,
        playerMedia: media.playerMedia,
        size: media.size,
        thumborSignedUrl: media.thumborSignedUrl,
        virtualName: media.virtualName,
        useClubBucket: media.useClubBucket
      };
    });
  }

  getPage() {
    const {
      id,
      name,
      content,
      published,
      liberationType,
      liberationDays,
      liberationDate,
      hasDuration,
      durationDays,
      pageLanguage
    } = Store.page;

    const cloneDeepPage = cloneDeep({
      id,
      name,
      content,
      published,
      liberationType,
      liberationDays,
      liberationDate,
      hasDuration,
      durationDays,
      pageLanguage
    });

    const page = normalizeDrippingDataFromMask(cloneDeepPage);

    page.content = this.getCustomContent(page.content);

    return page;
  }

  getCustomContent(content) {
    return htmlStringIsEmpty(content) ? '' : content;
  }

  customizeProps(snapshot) {
    const snapshotToReturn = { ...snapshot };

    this.removeDuplicateProps(snapshotToReturn);

    const { attachments } = snapshotToReturn;

    if (attachments) {
      snapshotToReturn.attachments = this.getAttachments(attachments);
    }

    return snapshotToReturn;
  }

  removeDuplicateProps(snapshot) {
    // There is tags property outsite page object already.
    // It is duplicated inside page object.
    if (snapshot.page && snapshot.page.tags) {
      delete snapshot.page.tags;
    }
  }
}

export default new ContentPagePreventLeaveService();
